import { useState } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_ADD_MAPPING } from "../../routes";
import { BisListingNotMappedStrings } from "../../components/media/bisListingNotMapped/locale";

export default function useAssociateMapping() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const associateMapping = async (mediaId, mediaMappingIds = [], onSuccess) => {
    if (!mediaId || !mediaMappingIds.length) return;

    setIsLoading(true);
    setError(null);

    try {
      await Promise.all(
        mediaMappingIds.map((mappingId) =>
          Api.put(API_ROUTE_ADD_MAPPING, null, {
            params: {
              mediaMappingId: mappingId,
              mediaId: mediaId,
            },
          }),
        ),
      );

      if (onSuccess) onSuccess();
    } catch (err) {
      const message =
        err?.response?.data?.detail ||
        BisListingNotMappedStrings.errors?.associationFailed;
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    associateMapping,
  };
}
